export default "__VITE_ASSET__02tvG6xS__"